import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { Tooltip } from "react-tooltip";
import { ListThree } from "./list-three";
import { colorCheck } from "../../utils/accessibility-helpers";

export const TableThree = (props) => {
  const sc = props.slice.primary;

  const fea = props.slice.items;

  const numOne = fea[0].feature_section.document.data.features;

  const numTwo = fea[1].feature_section.document.data.features;

  const numThree = fea[2].feature_section.document.data.features;

  const cat = [numOne, numTwo, numThree];

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  const anchor = sc.section_title.text.replace(/\s+/g, "-").toLowerCase();

  return (
    <section id={anchor} className={"relative " + space}>
      {sc.section_title.text ? (
        <div className="wrapper">
          <div
            className={
              "md:pb-16 md:text-center md:w-4/5 md:m-auto" +
              (sc.section_content.text ? " mb-4" : " mb-12")
            }
          >
            <PrismicRichText field={sc.section_title.richText} />
          </div>
        </div>
      ) : (
        ""
      )}
      {sc.section_content.text ? (
        <div className="wrapper">
          <div className={"md:text-center md:w-4/5 md:m-auto mb-12"}>
            <PrismicRichText field={sc.section_content.richText} />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="wrapper">
        {fea.map((f, index) => {
          return (
            <table
              key={index}
              className="hidden relative md:table mb-8 text-left border-spacing-8 border-collapse w-full"
            >
              <caption
                className={
                  "pt-3 pb-2 text-left !font-bold text-xl text-" +
                  colorCheck(f.feature_section.document.data.theme) +
                  (index === 0 ? " absolute" : "")
                }
              >
                {f.feature_section.document.data.type_of_service}
              </caption>
              <colgroup>
                <col className="w-2/5" />
                <col className="w-1/5" />
                <col className="w-1/5" />
                <col className="w-1/5" />
              </colgroup>
              <tr className={"relative comps text-center z-10 w-full"}>
                <th scope="col">{""}</th>
                <th
                  scope="col"
                  className={
                    "text-lg px-6 md:px-8 font-bold bg-white text-" +
                    colorCheck(sc.comp_one_theme) +
                    (index === 0 ? "" : " sr-only")
                  }
                >
                  <PrismicRichText field={sc.comp_one.richText} />
                </th>
                <th
                  scope="col"
                  className={
                    "text-lg px-6 md:px-8 font-bold bg-white text-" +
                    colorCheck(sc.comp_two_theme) +
                    (index === 0 ? "" : " sr-only")
                  }
                >
                  <PrismicRichText field={sc.comp_two.richText} />
                </th>
                <th
                  scope="col"
                  className={
                    "text-lg px-6 md:px-8 font-bold bg-white text-" +
                    colorCheck(sc.comp_three_theme) +
                    (index === 0 ? "" : " sr-only")
                  }
                >
                  <PrismicRichText field={sc.comp_three.richText} />
                </th>
              </tr>
              <tbody className={"th border-t border-grey-md"}>
                {f.feature_section.document.data.features.map((info, index) => {
                  return (
                    <tr key={index}>
                      <th scope="row">
                        {info.feature}
                        {info.tooltip ? (
                          <a
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={info.tooltip_content.text}
                          >
                            <i className="fa-solid fa-circle-question opacity-30" />
                            <Tooltip id="my-tooltip" place="right" />
                          </a>
                        ) : (
                          ""
                        )}
                      </th>
                      <td>
                        {info.comp_one ? (
                          <div>
                            <p className="sr-only">offers this feature</p>
                            <i
                              role="presentation"
                              className="fa-solid fa-check text-accessible-green"
                            />
                          </div>
                        ) : (
                          <div>
                            <p className="sr-only">
                              does not offer this feature
                            </p>
                            <i
                              role="presentation"
                              className="fa-solid fa-minus text-grey-md"
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        {info.comp_two ? (
                          <div>
                            <p className="sr-only">offers this feature</p>
                            <i
                              role="presentation"
                              className="fa-solid fa-check text-accessible-green"
                            />
                          </div>
                        ) : (
                          <div>
                            <p className="sr-only">
                              does not offer this feature
                            </p>
                            <i
                              role="presentation"
                              className="fa-solid fa-minus text-grey-md"
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        {info.comp_three ? (
                          <div>
                            <p className="sr-only">offers this feature</p>
                            <i
                              role="presentation"
                              className="fa-solid fa-check text-accessible-green"
                            />
                          </div>
                        ) : (
                          <div>
                            <p className="sr-only">
                              does not offer this feature
                            </p>
                            <i
                              role="presentation"
                              className="fa-solid fa-minus text-grey-md"
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        })}
        <div className="md:hidden">
          {cat.map((f, index) => {
            return (
              <ListThree
                key={index}
                number={index}
                slice={props.slice}
                cat={[...numOne, ...numTwo, ...numThree]}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};
